import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {FormCheckboxComponent} from './form-checkbox.component';
import {FormSelectComponent} from './app-select/form-select.component';
import {FormGroupComponent} from './form-group/form-group.component';
import {FormLabelComponent} from './form-label/form-label.component';
import {FormInputComponent} from './form-input/form-input.component';
import {DateInputComponent} from './form-date/components/date-input/date-input.component';
import {DatepickerComponent} from './form-date/components/datepicker/datepicker.component';
import {ClickOutsideDirective} from './form-date/directives/click-outside.directive';
import {FormRadioButtonsComponent} from './form-radio-buttons/form-radio-buttons.component';
import {FormTextareaComponent} from './form-textarea/form-textarea.component';
import {FindPositionDirective} from './form-date/directives/find-position.directive';
import {LayoutModule} from '@layoutComponents/layout.module';
import {FindPositionForDateSelectDirective} from './form-date/directives/find-position-for-date-select.directive';
import {FormDisabledInfoComponent} from './form-disabled-info.component';
import {FormResetButtonComponent} from './form-reset-button.component';
import {ErrorMessageComponent} from './error-message/error-message.component';
import { FormDateRangeComponent } from './form-date-range/form-date-range.component';
import { FormDateRangeDropdownComponent } from './form-date-range-dropdown/form-date-range-dropdown.component';
import {Lab365CommonModule} from '@lab365/common';
import {IconsModule} from '@lab365/icons';

@NgModule({
    declarations: [
        FormCheckboxComponent,
        FormSelectComponent,
        FormGroupComponent,
        FormLabelComponent,
        FormInputComponent,
        FormRadioButtonsComponent,
        FormTextareaComponent,

        FormDisabledInfoComponent,

        ClickOutsideDirective,
        FindPositionDirective,
        FindPositionForDateSelectDirective,
        DateInputComponent,
        DatepickerComponent,

        FormResetButtonComponent,
        ErrorMessageComponent,
        FormDateRangeComponent,
        FormDateRangeDropdownComponent,
    ],
    exports: [
        FormCheckboxComponent,
        FormSelectComponent,
        FormGroupComponent,
        FormLabelComponent,
        FormInputComponent,
        DateInputComponent,
        FormRadioButtonsComponent,
        FormTextareaComponent,
        FormDisabledInfoComponent,
        FormResetButtonComponent,
        FormDateRangeComponent,
        FormDateRangeDropdownComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        DirectivesModule,
        LayoutModule,
        Lab365CommonModule,
        IconsModule,
    ],
    providers: [

    ]
})
export class FormFieldModule {
}
